import { cn } from '../lib/utils';

const sizes = {
  sm: 'h-7 w-7 rounded-lg',
  md: 'h-8 w-8 rounded-xl',
} as const;

export function LogoMark({
  size = 'md',
  className,
}: {
  size?: keyof typeof sizes;
  className?: string;
}) {
  return (
    <div
      className={cn(
        'flex items-center justify-center bg-primary text-primary-foreground text-xs font-bold',
        sizes[size],
        className
      )}
    >
      R
    </div>
  );
}
